module.exports = __webpack_public_path__ + "static/media/08-min.1cd9ff40.png";